import { auth } from '@/datastore'
import { component } from 'vue-tsx-support'

export default component({
	name: 'SignOutPage',
	async mounted(): Promise<void> {
		await auth.signOut()
		this.$router.push('/')
	},
})
